import { EventEmitter, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class RelativePriceAdjustmentsCommonService {
  setRowNumbersEvent = new EventEmitter<any>();

  constructor() {}
}
